export const ARTICLE_IMG_FALLBACKS = {
  dental: "/img/articles/default-dental-cover.png",
  consulting: "/img/covers/consulting-growth-factor-guide.png",
  publishing: "/img/covers/creative-a-do-over.png",
};

export const articleImgFallback = (vertical) => ARTICLE_IMG_FALLBACKS[vertical] || ARTICLE_IMG_FALLBACKS.publishing;

export const onImgError = (vertical) => (e) => {
  const fallback = articleImgFallback(vertical);
  if (!e.currentTarget.src.endsWith(fallback)) {
    e.currentTarget.src = fallback;
  } else {
    e.currentTarget.style.display = "none";
  }
};
